// Index file for the directory. Don't add anything else here.
import CarouselTxnProcessUX from './CarouselTxnProcessUX';
export default CarouselTxnProcessUX;
